export default __webpack_public_path__ + "static/media/paper.ff877d2e.png";